<div role="menu" class="jeopardy-main-menu-grid">
  <div class="menu-item current-user">
    @if (!changeAvatarActive()) {
    <div class="avatar animated active" (click)="changeAvatarActive.set(true)">
      <img
        src="{{ currentUser().avatar }}"
        alt="{{ i18n.str('challengeu.main_avatar', 'Your avatar picture')() }}"
      />
      <i class="fa fa-cog"></i>
    </div>

    <h2 class="title">
      {{ i18n.str("challengeu.main_welcome", "Welcome")() }},
      {{ currentUser().username }}!
    </h2>
    } @else {
    <jeopardy-avatar-carousel
      [changeAvatarActive]="changeAvatarActive()"
      (changeAvatarClearChange)="changeAvatarActive.set($event)"
      [showSaveCancelBar]="true"
      (avatarSelectedUpdate)="avatarSelected.set($event)"
    >
    </jeopardy-avatar-carousel>
    }
  </div>
  @if (!gameInProgress()) {
  <div class="menu-item round-neon sp">
    <a
      href="#"
      (click)="selectModeSP($event, false)"
      title="Click to select beginner level"
    >
      <img
        src="assets/app-branding/img/icons/Icons_SinglePlayer2.png"
        alt="{{
          i18n.str(
            'challengeu.main_singleplayer',
            'Click to select beginner level'
          )()
        }}"
      />
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str('challengeu.main_beginner_level', "BEGINNER LEVEL")() }}
    </h2>
  </div>
  } @else {
  <div class="menu-item round-neon sp">
    <a href="#" (click)="continueGame($event)">
      <img
        src="assets/app-branding/img/icons/Icons_SinglePlayer2.png"
        alt="{{
          i18n.str('challengeu.main_continueGame', 'Continue current game')()
        }}"
      />
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str("challengeu.main_continueGame", "CONTINUE CURRENT GAME")() }}
    </h2>
  </div>
  } @if (!gameInProgress()) {
  <div class="menu-item round-neon mp">
    <a
      href="#"
      (click)="selectModeAM($event)"
      title="Click to select advanced level"
    >
      <img
        src="assets/app-branding/img/icons/Icons-mp-small.png"
        [alt]="
          i18n.str(
            'challengeu.main_advanced_level',
            'Click to select advanced level'
          )()
        "
      />
      <!-- alt="{{ i18n.str('challengeu.main_alt_multiplayer', 'Click to select multiplayer')() }}" -->
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str('challengeu.main_advanced_level', "ADVANCED LEVEL")() }}
    </h2>
  </div>
  } @else {
  <div class="menu-item round-neon mp">
    <a href="#" (click)="finishGame($event)">
      <img
        src="assets/app-branding/img/icons/Icons_SinglePlayer2.png"
        alt="{{
          i18n.str('challengeu.main_cancelGame', 'Cancel current game')()
        }}"
      />
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str("challengeu.main_cancelGame", "CANCEL CURRENT GAME")() }}
    </h2>
  </div>
  }

  <div class="menu-item round-neon rules">
    <a href="#" routerLink="/rules">
      <img
        src="assets/app-branding/img/icons/Icons-rules-small.png"
        alt="{{ i18n.str('challengeu.main_rules', 'Rules of the game')() }}"
      />
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str("challengeu.main_rules", "RULES OF THE GAME")() }}
    </h2>
  </div>
  <div class="menu-item round-neon leaderboard">
    <a href="#" routerLink="/leaderboard">
      <img
        src="assets/app-branding/img/icons/Icons-sp-small.png"
        alt="{{ i18n.str('challengeu.main_leaderboard', 'Leaderboard')() }}"
      />
    </a>
    <h2 class="jeopardy-text-shadow">
      {{ i18n.str("challengeu.main_leaderboard", "Leaderboard")() }}
    </h2>
  </div>
  <p class="menu-item round-neon music-off" [class.active]="!musicOff()">
    <a
      href="#"
      (click)="doMuteMusic($event)"
      title="{{ i18n.str('challengeu.main_music_off', 'Music off')() }}"
    >
      <img
        src="assets/app-branding/img/icons/Icons-music-small.png"
        alt="{{ i18n.str('challengeu.main_music_off', 'Music off')() }}"
      />
    </a>
  </p>
  <p class="menu-item round-neon sounds-off" [class.active]="!soundsOff()">
    <a
      href="#"
      (click)="setSoundsFX($event)"
      title="{{ i18n.str('challengeu.main_sounds_off', 'Sounds off')() }}"
    >
      <img
        src="assets/app-branding/img/icons/Icons-sounds-small.png"
        alt="{{ i18n.str('challengeu.main_sounds_off', 'Sounds off')() }}"
      />
    </a>
  </p>
  <p class="menu-item round-neon settings">
    <a
      href="#"
      routerLink="/settings"
      title="{{ i18n.str('challengeu.main_settings', 'Settings')() }}"
    >
      <img
        src="assets/app-branding/img/icons/Icons-settings-small.png"
        alt="{{ i18n.str('challengeu.main_settings', 'Settings')() }}"
      />
    </a>
  </p>
</div>

<div>
  <br />
  <p class="jeopardy-button primary">
    <a
      class="neon center"
      href="#"
      title="{{ i18n.str('challengeu.main_credits', 'CREDITS')() }}"
      routerLink="/credits"
    >
      {{ i18n.str("challengeu.main_credits", "CREDITS")() }}
    </a>
  </p>
  <div class="footer-version">
    <span>{{ versionNumber() }}</span>
  </div>
</div>
